import { Paper, Tab, Tabs } from "@material-ui/core";
import { School, Quiz, Help } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import EvaluationNotEnabled from "../Evaluation/EvaluationNotEnabled";
import { withAuthorization } from "../Session";
import FormationMenu from "./FormationMenu";
import TestMenu from "./TestMenu";
import { useTranslation } from "react-i18next";

var moment = require("moment");

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

const HomePage = (props) => {
  const { t } = useTranslation();
  const { lang, option, firebase } = props;
  const [value, setValue] = useState(!!!option ? 0 : option);
  const [isEvaluationOpen, setisEvaluationOpen] = useState(false);

  useEffect(() => {
    !!!option && setValue(option);
  }, [option]);

  useEffect(() => {
    /**
     * Usando el modulo de moment , se comprueba si estamos en un
     * periodo valido para hacer la evaluación
     *
     */
    firebase
      .user(firebase.currentUser().uid)
      .child("sgpfc")
      .once("value")
      .then((snap) => {
        let expires = snap.val().expires;
        let start = snap.val().starts;
        setisEvaluationOpen(moment(expires, "DDMMYYYY").fromNow().split(" ")[0] === "in" && moment(start, "DDMMYYYY").from().split(" ")[2] === "ago");
      });

    /**
     * Comprobar si el usuario tiene las evaluaciones superadas para ser rescatador
     */
    firebase.checkRescuer();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Paper square>
        <Tabs value={value} onChange={handleChange} variant="fullWidth" indicatorColor="secondary" textColor="secondary">
          <Tab icon={<School />} label={t("formation")} />
          <Tab
            icon={<Help />}
            //disabled={!isEvaluationOpen}
            label={t("evaluation")}
          />
        </Tabs>
      </Paper>
      <TabPanel value={value} index={0}>
        <FormationMenu />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TestMenu />
      </TabPanel>
    </>
  );
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(HomePage);
